<template>
  <v-app>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card>
          <v-card-title>
            <v-toolbar dense>
              <v-toolbar-title class="indigo--text" center >Informasi Peserta Ujian</v-toolbar-title>
            </v-toolbar>
          </v-card-title>

          <v-card-text>
            <!--<v-layout row wrap class="pb-3">
              <v-flex xs12 sm6 md6>
                <v-chip label>Program</v-chip>
                    <v-radio-group v-model="form.program" row @change="changeProgram">
                      <v-radio label="Non Pendas" value="np"></v-radio>
                      <v-radio label="Pendas" value="pd"></v-radio>
                    </v-radio-group>
              </v-flex>

              <v-flex xs12 sm6 md6 class="red lighten-4">
                <span class="indigo&#45;&#45;text">
                  Password peserta Ujian hanya ditampilkan pada saat ujian berlangsung, <br>(setiap karakter password bertanda * diganti dengan spasi)
                </span>
              </v-flex>
            </v-layout>-->

            <v-layout row class="pb-2" wrap>
              <v-flex xs12 sm4 md2>
                <v-card>
                  <v-card-text>
                    <v-text-field
                      label="Masa"
                      v-model="form.masa"
                      mask="#####"
                      required
                      hint="Contoh 20171"
                      @change="showTabel = false"
                    ></v-text-field>
                    <v-text-field
                      label="UPBJJ"
                      v-model="form.upbjj"
                      required
                      hint="Isi dengan kode UPBJJ"
                      @change="showTabel = false"
                    ></v-text-field>
                    <v-text-field
                      label="NIM Mahasiswa"
                      v-model="form.nim"
                      mask="#########"
                      required
                      @change="showTabel = false"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn :loading="loadingReload" :disable="loadingReload" round small color="indigo--text" @click="loadData()">
                      Tampilkan
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex xs12 sm8 md10>
                <v-card>
                  <v-card-text>
                    <v-data-table
                      v-bind:search="search"
                      v-bind:headers="headers"
                      v-bind:noResultsText="'Tidak ada data'"
                      v-bind:rowsPerPageText="'Baris / Halaman'"
                      v-bind:rowsPerPageItems="rowsperpage"
                      v-bind:items="items"
                      v-bind:pagination.sync="pagination"
                      class="elevation-1"
                      v-show="showTabel"
                    >
                      <template slot="headers" slot-scope="props">
                        <tr>
                          <th>No</th>
                          <th>NIM</th>
                          <th>Sesi</th>
                          <th>Mata Kuliah</th>
                          <th>Password</th>
                          <th>Jenis Ujian</th>
                          <th>Sifat Ujian</th>
                          <th>Kalkulator</th>
                          <th>Tabel</th>
                          <th>Kamus</th>
                        </tr>
                      </template>

                      <template slot="items" slot-scope="props">
                        <td class="text-xs-center">{{ props.index + 1 }}</td>
                        <td class="text-xs-center">{{ props.item.nim }}</td>
                        <td class="text-xs-center">{{ props.item.kode_sesi }}</td>
                        <td nowrap class="text-xs-left">({{ props.item.kode_mtk }}) {{ props.item.nama_mk }}</td>
                        <td class="text-xs-center">{{ props.item.password_mhs }}</td>
                        <td class="text-xs-center">{{ props.item.jenis_ujian === '1' ?'Objektif':'Uraian'}}</td>
                        <td nowrap class="text-xs-center">{{ props.item.sifat_ujian === '' ? '' : props.item.sifat_ujian === 'B' ? 'Buka Buku' : 'Tutup Buku' }}</td>
                        <td nowrap class="text-xs-center">{{ props.item.status_kalkulator === 'Y' ? 'Boleh' : 'Tidak Boleh' }}</td>
                        <td nowrap class="text-xs-center">{{ props.item.status_tabel === 'Y' ? 'Boleh' : 'Tidak Boleh' }}</td>
                        <td nowrap class="text-xs-center">{{ props.item.status_kamus === 'Y' ? 'Boleh' : 'Tidak Boleh' }}</td>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>

              </v-flex>
            </v-layout>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  </v-app>
</template>

<script>
  export default {
    created () {
    },
    data () {
      return {
        loadingReload: false,
        items: [],
        search: '',
        showTabel: false,
        modal: false,
        form: {
          masa: '',
          upbjj: '',
          nim: '',
          program: 'np'
        },
        headers: [],
        pagination: {
          sortBy: 'kode_sesi'
        },
        rowsperpage: [
          5,
          10,
          25,
          50,
          { text: '*', value: -1 }
        ]
      }
    },
    methods: {
      loadData: function () {
        let self = this

        self.showTabel = false

        if (self.form.masa.length !== 5) {
          self.$Notify.warning('Informasi', 'Pengisian Masa ujian belum sesuai')
          return
        }

        if (self.form.upbjj === '') {
          self.$Notify.warning('Informasi', 'Pengisian Kode UPBJJ belum sesuai')
          return
        }

        if (self.form.nim != null && self.form.nim.length >= 9) {
          self.loadingReload = true
          self.$Send.get(self.$CONFIG.WS_URL + 'ujian4web/getlistujian', {params: {params: self.form}}, function (result) {
            self.loadingReload = false
            if (result.response.state) {
              self.items = result.response.list
              self.showTabel = true
            } else {
              self.$Notify.warning('Informasi', result.response.msg)
            }
          }, function (e) {
            self.loadingReload = false
          })
        } else {
          self.$Notify.warning('Informasi', 'Pengisian NIM belum sesuai')
        }
      },
      changeProgram () {
        this.showTabel = false
        this.form.masa = ''
        this.form.kd_upbjj = ''
        this.form.nim = ''
      },
      save: function () {
        this.modal = false
        this.loadData()
      }
    }
  }
</script>

<style lang="stylus">
  @import '../stylus/main';
</style>



// WEBPACK FOOTER //
// src_suopass/pages/PesertaUjian.vue